import { APIClient, type APIClientOptions } from './http';

/**
 * Shared singleton API client.
 *
 * Each app configures it exactly once at bootstrap with its own platform
 * adapters; the per-domain endpoint objects (clientsAPI, ...) and the React
 * Query hooks then resolve this single instance lazily, so web and mobile reuse
 * the same transport and token-refresh flow without importing app code.
 */
let instance: APIClient | null = null;

/** Create (or replace) the shared API client. Call once per app at startup. */
export function configureApiClient(options: APIClientOptions): APIClient {
  instance = new APIClient(options);
  return instance;
}

/** Whether {@link configureApiClient} has been called. */
export function isApiClientConfigured(): boolean {
  return instance !== null;
}

/**
 * Access the shared API client. Throws if the app forgot to configure it — this
 * is a programming error, not a runtime condition to handle.
 */
export function getApiClient(): APIClient {
  if (!instance) {
    throw new Error(
      '@offertify/api-client: client not configured. Call configureApiClient() at app startup before using any endpoint or hook.',
    );
  }
  return instance;
}
